import { useState } from "react";

const features = [
  {
    id: 1,
    tag: "热点专题",
    title: "爆火街区探店全记录：排队两小时到底值不值？",
    intro:
      "一条短视频带火一个街区，新晋网红打卡地到底藏着什么秘密？我们用镜头记录从早到晚的真实排队实况、招牌美食的完整试吃测评，以及店主亲自分享的走红心得。",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20evening%20night%20market%20street%20full%20of%20food%20stalls%20and%20happy%20crowd%2C%20steaming%20delicious%20street%20food%2C%20cozy%20amber%20string%20lights%2C%20lively%20urban%20food%20culture%20documentary%20scene&width=1200&height=680&seq=feature-01&orientation=landscape",
    reads: "18.6万",
  },
  {
    id: 2,
    tag: "深度解析",
    title: "一场音乐节如何刷屏全网？万人合唱背后的情绪密码",
    intro:
      "从现场灯光到观众互动，我们拆解一场爆款音乐节走红的原因。不只是好看，更是一次属于年轻人的集体情绪表达，一起看懂它为什么能让人反复刷到。",
    image:
      "https://readdy.ai/api/search-image?query=Crowd%20singing%20together%20at%20outdoor%20music%20festival%20at%20dusk%20with%20warm%20pink%20and%20orange%20sky%2C%20colorful%20stage%20lights%2C%20joyful%20energetic%20festival%20atmosphere&width=1200&height=680&seq=feature-02&orientation=landscape",
    reads: "23.2万",
  },
  {
    id: 3,
    tag: "暖心瞬间",
    title: "暴雨中的那把伞：普通人善举让整座城市升温",
    intro:
      "暴雨突降的城市街头，无数陌生人停下脚步互相帮忙。我们用镜头记下这些最朴素的善意，也听当事人讲讲当时最真实的想法，温暖就是这么简单。",
    image:
      "https://readdy.ai/api/search-image?query=Heartwarming%20rainy%20street%20scene%20with%20strangers%20sharing%20umbrellas%20and%20helping%20each%20other%2C%20warm%20street%20lamp%20glow%20on%20wet%20ground%2C%20soft%20touching%20documentary%20photography&width=1200&height=680&seq=feature-03&orientation=landscape",
    reads: "12.9万",
  },
];

export default function FeatureSection() {
  const [active, setActive] = useState(features[0]);

  return (
    <section id="feature" className="bg-accent-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <p className="inline-flex items-center gap-1.5 rounded-full bg-accent-200 px-3 py-1 text-xs font-medium text-accent-900">
            <i className="ri-bookmark-line"></i>
            热点专题
          </p>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">
            深度专题，看懂吃瓜背后的故事
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600">
            不止是热门视频，更带你把热点背后的来龙去脉看得明明白白。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-5">
          <article className="lg:col-span-3 overflow-hidden rounded-lg bg-background-50 ring-1 ring-background-200">
            <div className="relative w-full">
              <img
                src={active.image}
                alt={active.title}
                title={`专题 ${active.title}`}
                className="aspect-[16/9] w-full object-cover"
              />
              <div className="absolute bottom-3 left-3 flex items-center gap-2">
                <button
                  type="button"
                  aria-label="播放专题视频"
                  className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-50"
                >
                  <i className="ri-play-fill text-xl"></i>
                </button>
                <span className="rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs text-background-50">
                  完整专题 08:26
                </span>
              </div>
            </div>
            <div className="p-5 md:p-6">
              <span className="inline-flex rounded-full bg-primary-100 px-2.5 py-0.5 text-xs font-medium text-primary-700">
                {active.tag}
              </span>
              <h3 className="mt-2 text-lg font-medium text-foreground-950 md:text-xl">
                {active.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-700">{active.intro}</p>
              <div className="mt-3 flex items-center gap-4 text-xs text-foreground-600">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {active.reads} 人次看过
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-thumb-up-line"></i>
                  8.9 万点赞
                </span>
              </div>
            </div>
          </article>

          <aside className="lg:col-span-2 flex flex-col gap-3">
            {features.map((f) => (
              <button
                key={f.id}
                type="button"
                onClick={() => setActive(f)}
                className={`flex items-center gap-3 rounded-lg p-3 text-left ring-1 transition-colors ${
                  active.id === f.id
                    ? "bg-primary-500 ring-primary-500"
                    : "bg-background-50 ring-background-200 hover:bg-background-100"
                }`}
              >
                <img
                  src={f.image}
                  alt={f.title}
                  title={`专题 ${f.title}`}
                  className="h-16 w-24 shrink-0 rounded-md object-cover"
                />
                <span>
                  <span
                    className={`line-clamp-2 text-sm font-medium ${
                      active.id === f.id ? "text-background-50" : "text-foreground-900"
                    }`}
                  >
                    {f.title}
                  </span>
                  <span
                    className={`mt-1 block text-xs ${
                      active.id === f.id ? "text-background-100/90" : "text-foreground-600"
                    }`}
                  >
                    <i className="ri-eye-line mr-1"></i>
                    {f.reads} 人次看过
                  </span>
                </span>
              </button>
            ))}
          </aside>
        </div>
      </div>
    </section>
  );
}